<script setup lang="ts">
import { computed } from "vue"
import i18n from '@/lang/i18n'

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: number
  items: { key: number, lavel: string }[]
  errorMessages: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <v-select
    v-model="modelValue"
    :items="props.items"
    :label="i18n.global.t('pages.departments.createOrUpdateModal.level')"
    item-title="label"
    item-value="key"
    outlined
    dense
    class="w-100"
    v-bind="{'return-object': true}"
    :clearable="false"
    :error-messages="props.errorMessages"
  />
</template>
